const axios = require("axios");
const NProgress = window.NProgress
NProgress.configure({ easing: "ease", speed: 500, showSpinner: false });

const httpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

const insecuredHttpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

const getAuthToken = () => localStorage.getItem("token");

const authInterceptor = (config) => {
  config.headers["Authorization"] = getAuthToken();
  return config;
};

httpClient.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

httpClient.interceptors.response.use(
  (response) => {
    NProgress.done(true);
    return response;
  },
  (error) => {
    NProgress.done(true);
    return Promise.reject(error);
  }
);
insecuredHttpClient.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

insecuredHttpClient.interceptors.response.use(
  (response) => {
    NProgress.done();
    return response;
  },
  (error) => {
    NProgress.done();
    return Promise.reject(error);
  }
);

httpClient.interceptors.request.use(authInterceptor);

export { httpClient, insecuredHttpClient };
